module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/big/6-4e23a3aabee4e0183d053d4f955b84c0.webp";